export default __webpack_public_path__ + "static/media/co.495b2e96.jpg";